import SafeIcon from './SafeIcon';
import { useApp } from '../i18n/AppContext';
import { useUi } from '../store/ui';

export default function ReportsPage() {
  const { translate } = useApp();
  const { showPlannedFeatureNotice } = useUi();
  const channelPerformanceRows = [
    ['Instagram', '8,420', '65%'],
    ['Facebook', '6,210', '48%'],
    ['TikTok', '7,840', '72%'],
    ['LinkedIn', '2,330', '31%'],
  ];
  return (
    <div className="content-stack">
      <div className="page-title-row">
        <div>
          <h1>{translate('Reports')}</h1>
          <p className="subtitle">
            {translate("A simple view of what's working this month.")}{' '}
            <span className="tag">{translate('Sample figures')}</span>
          </p>
        </div>
        <button className="button" onClick={() => showPlannedFeatureNotice('Export a report')}>
          <SafeIcon name="FiDownload" />
          {translate('Export report')}
        </button>
      </div>
      <div className="summary-row">
        <div className="summary-card">
          <strong>24.8k</strong>
          <span>{translate('Reach this month · +18%')}</span>
        </div>
        <div className="summary-card">
          <strong>6.4%</strong>
          <span>{translate('Engagement · +0.8%')}</span>
        </div>
        <div className="summary-card">
          <strong>32</strong>
          <span>{translate('Posts published')}</span>
        </div>
      </div>
      <div className="panel">
        <h2>{translate('Channel performance')}</h2>
        {channelPerformanceRows.map(([channel, reach, width]) => (
          <div className="checklist-item" key={channel}>
            <strong style={{ width: 100 }}>{channel}</strong>
            <div style={{ flex: 1 }}>
              <div className="progress-track">
                <span style={{ width }} />
              </div>
            </div>
            <span className="muted">{translate('{x} reach', { x: reach })}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
